import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

//Actions
import { getQuestionList, getAnsweredQuestionCount, resetSingleItemSlider } from '../../../../../actions/SurveyAction';
import Slider from 'react-rangeslider';
// To include the default styles
import 'react-rangeslider/lib/index.css'

class SingleSelectSliderResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            answeredQuestion:0,
            sliderValue:null,
            optFirstLabel:null,
            optLastLabel:null,
            minValue:null,
            maxValue:null,
            selectedLabel:null
        };
        this.labels = {};
        this.tempArr = [];
        this.reviewPage = this.props.questionItemList || [];
        this.answeredQuestion = 0;
        this.responseCount = 0;
        this.rateeCount = 0;
        
    }

    static getDerivedStateFromProps(props, state) {
        if (props.singleItemSliderValue) {
            return {
                sliderValue: props.singleItemSliderValue,
                selectedLabel:null
            }
        }
        return true;
    }
    
    componentDidMount() {
        const { configuration } = this.props;
        /* Manage the selected label */
        configuration.scaleResponses.map((itm, i) => {
            if (itm.responseValue !== null) {
                this.tempArr[i] = itm.responseValue;
                this.labels[itm.responseValue] = itm.responseValue;
            }
            return null;
        });

        /* Get the min and max value */
        var max = this.tempArr.reduce((a, b) => {
            return Math.max(a, b);
        });

        var min = this.tempArr.reduce((a, b) => {
            return Math.min(a, b);
        });

        /* Hide/Show label based on first and last label of response */
        configuration.scaleResponses.filter((scale, i) => {
            if (scale.responseValue === min) {
                this.setState({optFirstLabel:scale.responseDescription})
            }
            if (scale.responseValue === max) {
                this.setState({optLastLabel:scale.responseDescription})
            }
            return null;
        });

        this.setState({maxValue:max, sliderValue:min, minValue:min});
    }


    handleChange = (value, configuration, rateeKey, type) => {
        const { items, dispatch, showSpinner } = this.props;
        var e = value;

        this.setState({sliderValue: value});
        dispatch(resetSingleItemSlider(null));

        var selectedValue = type === "select" ? e.target.value : e;
        var answeredQuestion = 0;

        /* Manage the question answered response */
        this.reviewPage.map((itemsValue, i) => {

            if (itemsValue.key === items.key) {
                this.reviewPage[i].isAnswer = true;
                this.reviewPage[i].isRequired = true;
                const ratees = itemsValue.ratees;

                /* Based on ratee key manage the response */
                for (const key in ratees) {
                    if (ratees.hasOwnProperty(key)) {
                        const tempRatees = ratees[key];
                        this.rateeCount = this.reviewPage[i].ratees.length || 0;

                        if (tempRatees.key === rateeKey) {
                            configuration.filter((option, inx) => {
                                if (parseInt(selectedValue) !== 0 && parseInt(selectedValue) === option.responseValue) {
                                    this.reviewPage[i].userResponse[key] = {
                                        "userKey":option.response,
                                        "rateeKey":tempRatees.key,
                                        "userResponseDescription":option.responseDescription,
                                        "responseValue":selectedValue,
                                    }

                                    /* Get selected value label */
                                    if (parseInt(selectedValue) !== this.state.minValue && parseInt(selectedValue) !== this.state.maxValue) {
                                        this.setState({selectedLabel:option.responseDescription});
                                    } else {
                                        this.setState({selectedLabel:null});
                                    }
                                }
                                var userResponseCont = this.reviewPage[i].userResponse.filter((el) => el != null);
                                this.responseCount  = userResponseCont.length || 0;
                                return null;
                            });
                        } else {
                            this.responseCount = 0;
                        }
                    }
                }
            } else {
                if (this.reviewPage[i].isAnswer !== true) this.reviewPage[i].isAnswer = false;
            }
            
            /* Question answer count */
            // var userResponseCont = this.reviewPage[i].userResponse.length || 0;
            // var rateesCount = this.reviewPage[i].ratees.length || 0

            // if (userResponseCont === rateesCount) {
            //     answeredQuestion++;
            // }
            return null;
        });

        /* Dispatch the action */
        // const { answeredQuestionCount } = this.props;
        // const tempAnsweredQuestionCount = answeredQuestionCount !== undefined ? answeredQuestionCount : 0;
        // dispatch(getAnsweredQuestionCount(tempAnsweredQuestionCount + 1));
        dispatch(getQuestionList(this.reviewPage));
        showSpinner(items.key);
        this.handleThumb(this.state.sliderValue)
    }

    /**
     * Method to fill the slider thumb
     * 
     * @param {sliderVal:Number} sliderVal 
     */
    handleThumb = (sliderVal) => {
        try {
            const { minValue } = this.state;
            
            var sliderThumb = document.getElementsByClassName("rangeslider-horizontal")[0];
            var sliderThumbChild = sliderThumb.getElementsByClassName("rangeslider__handle")[0];

            if (minValue === sliderVal) {
                sliderThumbChild.style.background = "#fff";
            } else {
                sliderThumbChild.style.background = "#0f5ea0";
            }
            
        } catch (error) {
            console.log("Exception: While slider thumb in single select slider:_", error);
        }
    };
   
    handleChangeStart = () => {
        try {
            const { dispatch, answeredQuestionCount } = this.props;
            this.answeredQuestion++;
            
            const tempAnsweredQuestionCount = answeredQuestionCount !== undefined ? answeredQuestionCount : 0;

            if (this.answeredQuestion === this.rateeCount && this.responseCount !== 0) {
                dispatch(getAnsweredQuestionCount(tempAnsweredQuestionCount + 1));
            } else {
                dispatch(getAnsweredQuestionCount(tempAnsweredQuestionCount - 1));
                this.answeredQuestion = 0;
            }
        } catch (error) {
            console.log("Exception: while count given answer in single slider response:_", error);
        }   
    }

    render() {
        const { configuration, rateeKey, items, resClass, singleItemSliderValue } = this.props;
        const { optFirstLabel, sliderValue, maxValue, minValue, optLastLabel, selectedLabel } = this.state;
        var restoreLabel = [];

        if (singleItemSliderValue !== null) {
            restoreLabel = configuration.scaleResponses.filter((option, inx) => {
                return option.responseValue === singleItemSliderValue ? option.responseDescription: null
            });
        }

        return (
            <Fragment>
                {/* { suppressLabel ? null : <span className=''></span> } */}
                <div className={resClass} key={items.key}>
                    <span className="slider-left-label">{optFirstLabel}</span>
                    <Slider
                        className={`Single_slider_${items.items.key}`} 
                        min={minValue}
                        max={maxValue}
                        value={sliderValue}
                        handleLabel={restoreLabel.length === 0 ? selectedLabel : singleItemSliderValue !== minValue ? restoreLabel[0].responseDescription: null }
                        tooltip={false}
                        onChangeComplete={this.handleChangeStart}
                        onChange={(event) => this.handleChange(event, configuration.scaleResponses, rateeKey, "slider")}
                    />
                    <span className="slider-right-label">{optLastLabel}</span>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    singleItemSliderValue:state.survey.singleItemSliderValue,
    answeredQuestionCount:state.survey.answeredQuestionCount
});

export default connect(mapStateToProps)(SingleSelectSliderResponse);
